import Button from "devextreme-react/button";
import { useCallback, useContext } from "react";
import { ThemeContext } from "../../theme/theme";

export const ThemeSwitcher = () => {
  const themeContext = useContext(ThemeContext);

  const onButtonClick = useCallback(() => {
    themeContext?.switchTheme();
  }, [themeContext]);

  return (
    <div>
      <Button
        className="theme-button"
        stylingMode="text"
        icon={`${themeContext?.theme !== "dark" ? "moon" : "sun"}`}
        onClick={onButtonClick}
        activeStateEnabled={false}
        focusStateEnabled={false}
        hoverStateEnabled={false}
      />
    </div>
  );
};
